import { type DashboardData } from '../../types';

export function pushHierarchy(
  parentId: string | null,
  itemsByParentId: Map<string | null, DashboardData[]>,
  sortedData: DashboardData[],
) {
  const children = [...(itemsByParentId.get(parentId) ?? [])].sort((a, b) => a.order - b.order);

  for (const child of children) {
    sortedData.push(child);
    pushHierarchy(child.id, itemsByParentId, sortedData);
  }
}
